export const SET_NAVIGATE_TO = 'SET_NAVIGATE_TO';
export const NAVIGATE_TO = 'NAVIGATE_TO';
export const SET_BASE_PATH = 'SET_BASE_PATH';
export const BASE_PATH = 'BASE_PATH';

export type TSetNavigationAction = {
    type: string;
    payload: {
        navigate: (path: string) => void;
    };
};

export type TNavigationAction = {
    type: string;
    payload: {
        path: string;
    };
};

export type TSetBasePath = {
    type: string;
    payload: {
        basePath: string;
    };
};

export const setNavigateTo = (
    navigate: TSetNavigationAction['payload']['navigate']
): TSetNavigationAction => ({
    type: SET_NAVIGATE_TO,
    payload: {
        navigate
    }
});

export const navigateTo = (path: TNavigationAction['payload']['path']) => ({
    type: NAVIGATE_TO,
    payload: { path }
});

export const setBasePath = (basePath: string): TSetBasePath => ({
    type: SET_BASE_PATH,
    payload: {
        basePath
    }
});
